// PrivateRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

type PrivateRouteProps = {
  element: JSX.Element;
};

export const PrivateRoute = ({ element }: PrivateRouteProps) => {
  const { user } = useAuth();
  return user ? element : <Navigate to="/login" />;
};
